<template>
  <section
    id="cennik"
    class="scroll-mt-[48px] flex min-w-0 flex-col gap-3 rounded-xl bg-white p-4 shadow-[0px_6px_7.5px_rgba(16,24,40,0.08)] lg:scroll-mt-[64px] lg:p-6"
  >
    <h2 class="text-sm font-semibold uppercase tracking-[1px] text-neutral-500">
      {{ $t('specialists.price_list') }}
    </h2>

    <div
      class="flex w-full items-center gap-2 overflow-hidden rounded-lg border border-solid border-[#2ea8cf] px-6 py-4"
      style="background-image: linear-gradient(174.036deg, rgba(46, 168, 207, 0.1) 0%, rgba(40, 182, 155, 0.1) 100%)"
      role="status"
    >
      <img
        v-if="requiresPrepayment"
        :src="payuLogo"
        alt="PayU"
        class="h-6 w-12 shrink-0 object-contain"
        width="48"
        height="24"
      >
      <Icon
        v-else
        name="banknotes"
        class="size-5 shrink-0 text-[#2ea8cf]"
        aria-hidden="true"
      />
      <p class="text-base font-medium leading-6 text-[#0e6886]">
        {{
          requiresPrepayment
            ? $t('specialists.prepayment_payu')
            : $t('specialists.payment_on_site')
        }}
      </p>
    </div>

    <ul class="flex min-w-0 flex-col">
      <li
        v-for="service in services"
        :key="service.remote_uuid || service.id"
        class="flex min-w-0 flex-wrap items-center justify-between gap-3 border-b border-neutral-200 py-4"
      >
        <div class="flex min-w-0 flex-1 flex-col gap-1">
          <p class="min-w-0 break-words text-base leading-6 text-neutral-900">
            {{ service.name }}
          </p>
          <p
            v-if="formatServiceMeta(service)"
            class="text-sm font-semibold leading-4 text-green-600"
          >
            {{ formatServiceMeta(service) }}
          </p>
        </div>

        <div
          v-if="service.remote_uuid === selectedUuid"
          class="flex shrink-0 items-center gap-2 px-5 py-3.5 text-base font-semibold leading-[18px] text-sky-700"
        >
          <Icon name="check" class="size-5 shrink-0" aria-hidden="true" />
          <span>{{ $t('specialists.selected_service') }}</span>
        </div>

        <button
          v-else
          type="button"
          class="flex h-12 shrink-0 items-center justify-center gap-2 rounded-lg px-5 py-3.5 text-base font-semibold leading-[18px] text-white shadow-[0px_2px_3px_rgba(16,24,40,0.06)] transition-opacity hover:opacity-90"
          :style="{ backgroundImage: 'linear-gradient(160.691deg, rgb(46, 168, 207) 0%, rgb(40, 182, 155) 100%)' }"
          @click="$emit('select', service.remote_uuid)"
        >
          {{ $t('common.book_appointment') }}
        </button>
      </li>
    </ul>
  </section>
</template>

<script>
import { formatServiceMeta } from '@/utils/serviceMeta';
import Icon from '@/Shared/Icon.vue';
import payuLogo from '@/images/components/payu-logo.png';

export default {
  name: 'SpecialistPriceList',
  components: { Icon },
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    selectedUuid: {
      type: String,
      default: null,
    },
    requiresPrepayment: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select'],
  data() {
    return {
      payuLogo,
    };
  },
  methods: {
    formatServiceMeta(service) {
      return formatServiceMeta(service);
    },
  },
};
</script>
